import { environment } from 'environments/environment';
import { ApplicationConfigDefinition } from '@data/common/ApplicationConfigDefinition';

export const ApplicationConfig: ApplicationConfigDefinition = {
  applicationOwner: 'Apzumi',
  applicationName: 'AgataZajacFitness',
  version: '0.1.0 (2024-07-31)',
  environmentName: environment.name,
  production: environment.production,
  apiUrl: environment.apiUrl,
  cognito: environment.cognito,
  defaultLanguage: environment.defaultLanguage
};
